import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ApiService } from '../api.service';
import { Endpoint } from './uc.service';

export interface UCClassification {
  'id'?: number;
  'name'?: string;
}

@Injectable()
export class UCClassificationService {

  private options: any;

  constructor(
    private apiService: ApiService
  ) { }

  getAll(): Observable<any> {
    return this.apiService.client.ucClassification.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/uc-classification.service.ts